export const MILITARY_EXPERIENCE = {
  CURRENTLY_ENLISTED: 'currently_enlisted',
  PREVIOUSLY_ENLISTED: 'previously_enlisted',
  NO: 'no',
};
